import React from "react";
import PropTypes from "prop-types";
import { ReactComponent as Spanner } from "assets/svg/spanner.svg";
import T from "i18n";
import Base from "./Base";

const MoreTechInfo = ({ className }) => {
  const classes = ["MoreTechInfo"];
  if (className) classes.push(className);

  return (
    <Base
      className={className}
      Svg={Spanner}
      label={T({ path: "button.moreTechInfo" })}
    />
  );
};

MoreTechInfo.displayName = "MoreTechInfo";

MoreTechInfo.propTypes = {
  className: PropTypes.string,
};

MoreTechInfo.defaultProps = {
  className: null,
};

export default MoreTechInfo;
